<div *ngIf="representantes">
  <app-z-dialog
    [title]="'Representantes ' + representantes.length"
    [contentTemplate]="contentTemplate"
    [actionButtonsTemplate]="buttonsTemplate"
  >
  </app-z-dialog>

  <ng-template #contentTemplate>
    <section class="d-flex flex-column">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let rep of representantes"
          class="modules-panel border"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ rep.nome }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <section class="modules-panel border">
            <div style="padding-top: 15px">
              <ul>
                <li>
                  Email: {{ rep.email ? rep.email : "E-mail não encontrado" }}
                </li>
                <li>
                  CPF:
                  {{
                    rep.cpfcnpj
                      ? maskpipe.transform(rep.cpfcnpj, cpf_mask)
                      : "CPF não encontrado"
                  }}
                </li>
                <li>
                  Telefone:
                  {{
                    rep.telefone
                      ? (rep.telefone | telefone)
                      : "Telefone não encontrado"
                  }}
                </li>
              </ul>
            </div>
          </section>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
  </ng-template>
  <ng-template #buttonsTemplate>
    <z-button
      icon="add_circle_outline"
      [label]="'Novo Representante'"
      [mat-dialog-close]="true"
      cdkFocusInitial
    >
    </z-button>
  </ng-template>
</div>

<div *ngIf="originadores">
  <app-z-dialog
    [title]="'Originadores ' + originadores.length"
    [contentTemplate]="contentTemplate"
    [actionButtonsTemplate]="buttonsTemplate"
  >
  </app-z-dialog>

  <ng-template #contentTemplate>
    <section class="d-flex flex-column">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let origin of originadores"
          class="modules-panel border"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ origin.pessoa.nome }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <section class="modules-panel border">
            <div style="padding-top: 15px; padding-right: 25px">
              <ul>
                <li>
                  Email:
                  {{
                    origin.pessoa.email
                      ? origin.pessoa.email
                      : "E-mail não encontrado"
                  }}
                </li>
                <li>
                  CNPJ:
                  {{
                    origin.pessoa.cpfcnpj
                      ? maskpipe.transform(origin.pessoa.cpfcnpj, cnpj_mask)
                      : "CPF não encontrado"
                  }}
                </li>
                <li>
                  Telefone:
                  {{
                    origin.pessoa.telefone
                      ? (origin.pessoa.telefone | telefone)
                      : "Telefone não encontrado"
                  }}
                </li>
                <li>
                  Código Originador:
                  {{
                    origin.codigoConsultoria
                      ? origin.codigoConsultoria
                      : "Código não encontrado"
                  }}
                </li>
              </ul>
            </div>
          </section>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
  </ng-template>
  <ng-template #buttonsTemplate>
    <z-button
      icon="add_circle_outline"
      label="Novo Originador"
      [mat-dialog-close]="true"
    >
    </z-button>
  </ng-template>
</div>
